import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// 路由
export const constantRoutes = [
  {
    path: "/",
    redirect: "/index",
    hidden: true
  },
  {
    path: "/index",
    name: "index",
    hidden: true,
    component: () => import("@/views/index.vue")
  },
  {
    path: "/planIntroduce",
    name: "planIntroduce",
    hidden: true,
    component: () => import("@/views/planIntroduce.vue")
  },
  {
    path: "/talentIntroduce",
    name: "talentIntroduce",
    hidden: true,
    component: () => import("@/views/talentIntroduce.vue")
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    hidden: true,
    component: () => import("@/views/aboutUs.vue")
  },
  {
    path: "/contactUs",
    name: "contactUs",
    hidden: true,
    component: () => import("@/views/contactUs.vue")
  },
]

const createRouter = () =>
  new Router({
    // mode: "history", // 去掉url中的#
    mode: "hash",
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });
let router = createRouter();

/**
 * 重写路由的push方法,防止连续点击多次路由报错
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js